import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilsService } from '../../../shared/services/utils.service';
import { CommonModule } from '@angular/common';
import { WriteReviewService } from '../../../shared/services/write-review.service';

@Component({
  selector: 'app-write-review',
  standalone: true,
  imports: [CommonModule,FormsModule,ReactiveFormsModule],
  templateUrl: './write-review.component.html',
  styleUrl: './write-review.component.scss'
})
export class WriteReviewComponent implements OnInit,OnDestroy {
  environment: any = environment;
  reviewForm!: FormGroup;
  sub:Subscription=new Subscription()
 

  constructor(
    public dialogRef: MatDialogRef<WriteReviewComponent>,
    public utils: UtilsService,
    public service: WriteReviewService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.utils.showHeaderFooter.next(true);
  }

  ngOnInit() {
    this.reviewForm = this.toFormGroup(this.data)
  }

  onNoClick(event: any) {
    this.dialogRef.close(event);
  }

  toFormGroup(reviewAttributes: any) {
    const group: any = {};

    reviewAttributes.reviews.forEach((attribute: any) => {
      group[attribute.reviewSubGuidId] = new FormControl((attribute.rating == 0 || !this.data.isReviewSubmitted) ? 0 : Math.round(attribute.rating) || '', Validators.required)
    });
    group['title'] = new FormControl(reviewAttributes.title, Validators.required)
    group['description'] = new FormControl(reviewAttributes.description, Validators.required)
    return new FormGroup(group);
  }
  onSubmit() {
    let reviewsArray: any = []
    for (const property in this.reviewForm.value) {
      if (property != 'title' && property != 'description')
        reviewsArray.push({
          "reviewSubGuidId": property,
          "rating": this.reviewForm.value[property]
        })
    }
    let body: any = {
      productName:this.data.productName,
      reviews: reviewsArray
    }
    if (this.data.isReviewSubmitted) {
      body['reviewGuidId'] = this.data.reviewGuidId,
        body['reviewTitle'] = this.reviewForm.value.title,
        body['reviewDescription'] = this.reviewForm.value.description
    }
    else {
      body['title'] = this.reviewForm.value.title,
        body['description'] = this.reviewForm.value.description
    }
    this.utils.showLoading()
    this.sub.add(  this.service.submitReview(body, this.data.isReviewSubmitted).subscribe(
      (response: any) => {
        if (response) {
          this.utils.hideLoading()
          this.dialogRef.close(true)
        }
        else {
          this.utils.hideLoading()
          this.utils.openSnackBar(response.message, 'error-toster')
        }
      }
    ))
  }

  setRatingValue(formControlName: any, value: any) {
    this.reviewForm.controls[formControlName].setValue(value)
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}